import React from 'react';
import { FilterLink, SelectLinks } from '../../../_lib/components/SelectLinks/SelectLinks';
import { useSonTranslation } from '../../../translation/useSonTranslation';

export type ContactPersonsFilter = FilterLink<'contactpersons' | 'all' | 'none'>;

export type ContactPersonsFilterProps = {
  contactPersons: ContactPersonsFilter[];
};

export function ContactPersonsFilter({ contactPersons }: ContactPersonsFilterProps) {
  const { t } = useSonTranslation('StructuralPageToPage');

  const mappedLinksWithTranslation = contactPersons?.map(link => ({
    ...link,
    name: t(`filter.contactPersons.${link.name}`),
  }));
  return (
    mappedLinksWithTranslation && (
      <div className="structural-page-to-page-tree__filters-box">
        <SelectLinks headline={t('filter.contactPersons.headline')} links={mappedLinksWithTranslation} />
      </div>
    )
  );
}
